/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_EnhancedWorkScheduleDTO } from '../models/Routemize_DTOs_EnhancedWorkScheduleDTO';
import type { Routemize_DTOs_UpdateEnhancedWorkScheduleDTO } from '../models/Routemize_DTOs_UpdateEnhancedWorkScheduleDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyWorkScheduleService {
    /**
     * @returns Routemize_DTOs_EnhancedWorkScheduleDTO OK
     * @throws ApiError
     */
    public static getApiAppCompanyWorkScheduleGetEnhancedWorkSchedule(): CancelablePromise<Routemize_DTOs_EnhancedWorkScheduleDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/companyWorkSchedule/getEnhancedWorkSchedule',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_EnhancedWorkScheduleDTO OK
     * @throws ApiError
     */
    public static putApiAppCompanyWorkScheduleUpdateEnhancedWorkSchedule(
        requestBody?: Routemize_DTOs_UpdateEnhancedWorkScheduleDTO,
    ): CancelablePromise<Routemize_DTOs_EnhancedWorkScheduleDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/companyWorkSchedule/updateEnhancedWorkSchedule',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppCompanyWorkScheduleInitializeDefaultSchedule(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/companyWorkSchedule/initializeDefaultSchedule',
        });
    }
}
